var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pro_input_add ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text",
    class: {
      pro_input_add_detail: _vm.detail
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "particle"
  }, _vm._l(_vm.list, function (item, index) {
    return _c('span', {
      key: index,
      staticClass: "item border-[#DFE4EE] border-solid border-[1px] rounded-sm p-[5px]"
    }, [_c('Icon', {
      staticClass: "mr-[2px] text-[#2d8cf0]",
      attrs: {
        "type": _vm.iconRender(item)
      }
    }), _vm._v(" " + _vm._s(item.name) + " ")], 1);
  }), 0), !_vm.detail ? _c('span', {
    staticClass: "iconfont icon-add",
    class: _vm.icon
  }) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };